import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import { defineComponent as _defineComponent } from 'vue';
import { detectEnv } from '@/shared/detect';
import yxhJsBridge from '@/shared/yxhJsBridge';
import { computed, watch, nextTick, ref, useSlots } from 'vue';
var __default__ = {
    name: 'XPopup',
    inheritAttrs: false
};
export default /*#__PURE__*/ _defineComponent(_object_spread_props(_object_spread({}, __default__), {
    props: {
        /**
   * 是否显示弹出层
   * @@defaultValue false
   */ value: {
            type: Boolean,
            default: false
        },
        /**
   * 标题
   */ title: String,
        /**
   * 是否开启顶部安全区处理
   * @defaultValue false
   */ safeAreaInsetTop: {
            type: Boolean,
            default: false
        },
        /**
   * 是否开启底部安全区处理
   * @defaultValue false
   */ safeAreaInsetBottom: {
            type: Boolean,
            default: false
        },
        /**
   * 关闭图标位置
   * @defaultValue 'top-right'
   */ closeIconPosition: {
            type: String,
            validator: function validator(value) {
                return [
                    'top-left',
                    'top-center',
                    'top-right',
                    'bottom-left',
                    'bottom-center',
                    'bottom-right'
                ].includes(value);
            },
            default: 'top-left'
        },
        /**
   * 是否开启拦截Android物理返回键用于关闭弹窗
   * @remarks 该功能仅在宜享花Android App中有效
   * @defaultValue true
   */ closeWhenAppBack: {
            type: Boolean,
            default: true
        },
        position: {
            type: String,
            validator: function validator(value) {
                return [
                    'center',
                    'top',
                    'bottom',
                    'right',
                    'left'
                ].includes(value);
            },
            default: 'center'
        }
    },
    emits: [
        "input"
    ],
    setup: function setup(__props, param) {
        var emit = param.emit;
        var props = __props;
        var slots = useSlots();
        var hasNavBar = computed(function() {
            return slots.title || props.title != null && props.title !== '' || slots.action;
        });
        var header = ref(null);
        var footer = ref(null);
        var contentHeight = ref('auto');
        var maxWidth = computed(function() {
            if (props.position === 'center') {
                return '414px';
            }
            return 'none';
        });
        // 计算内容区域高度
        // flex: 1在部分iOS机型上没有效果
        watch(function() {
            return props.value;
        }, function(visible) {
            if (visible) {
                nextTick(function() {
                    var otherHeight = 0;
                    if (header.value) {
                        otherHeight += header.value.clientHeight;
                    }
                    if (footer.value) {
                        otherHeight += footer.value.clientHeight;
                    }
                    if (otherHeight > 0) {
                        contentHeight.value = "calc(100% - ".concat(otherHeight, "px)");
                    }
                });
            }
        });
        var onInput = function onInput(visible) {
            emit('input', visible);
        };
        // 在宜享花APP中当弹窗展示的时，拦截物理键后退，当物理键触发时先关闭弹窗。
        if (detectEnv.yxh) {
            var unwatch;
            watch(function() {
                return props.value;
            }, function(visible) {
                if (!props.closeWhenAppBack) return;
                if (visible) {
                    unwatch = yxhJsBridge.watchAppBack(function() {
                        emit('input', false);
                    });
                } else {
                    unwatch === null || unwatch === void 0 ? void 0 : unwatch();
                }
            });
        }
        return {
            __sfc: true,
            props: props,
            emit: emit,
            slots: slots,
            hasNavBar: hasNavBar,
            header: header,
            footer: footer,
            contentHeight: contentHeight,
            maxWidth: maxWidth,
            onInput: onInput
        };
    }
}));
